import React, { Component } from "react";
import {
    GridColumn,
    Grid,
    GRID_COL_INDEX_ATTRIBUTE,
    GridNoRecords,
} from "@progress/kendo-react-grid";
import { withState } from "./grid";
import Moment from "react-moment";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { Button, Modal, Tooltip, message } from "antd";
import store from "../../store";
import apiCalls from "../../api/apiCalls";
import { clearGridFiltersFalse, refreshGridFalse, resetGridLayoutFalse, saveGridLayoutFalse } from "src/reducers/gridLayoutReducer";
import { connect } from "react-redux";
import { ColumnMenu } from "./columnMenu";
const StatefullGrid = withState(Grid);
class List extends Component {
    constructor(props) {
        super(props);
        this.eleRef = React.createRef();
        this.state = {
            columns: [],
            layoutHasChanged: false,
            dataState: {},
            loading: true,
            isBtnLoading: false,
            featureId: store.getState().permissions?.currentScreenTabId || store.getState().permissions?.currentScreenId,
            customerId: store.getState().oidc?.user?.currentUser?.id,
            saveGridModalIsVisible: store.getState().saveGridModal?.saveGridModalIsVisible,
            //saveGridLayout: store.getState().gridLayout?.saveGridLayout,
            saveGridLayout: this?.props?.gridLayout?.saveGridLayout,
            resetGridLayout: store.getState().gridLayout?.resetGridLayout,
            username: store.getState().userConfig?.userProfileInfo?.userName
        };
        this.handleColumnReorder = this.handleColumnReorder.bind(this);
        this.gridFilterData = this.gridFilterData.bind(this);
    }
    componentDidMount() {
        this.getGridColumns(this.props.screenName, this?.state?.customerId)
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.gridLayout.saveGridLayout === false && this.props.gridLayout.saveGridLayout === true) {
            this.onSaveHandler();
        }
        if (prevProps.gridLayout.resetGridLayout === false && this.props.gridLayout.resetGridLayout === true) {
            this.resetToDefault();
        }
        if (prevProps.gridLayout.clearGridFilters === false && this.props.gridLayout.clearGridFilters === true) {
            this.clearGridFilters();
        }
        if (prevProps.gridLayout.refreshGrid === false && this.props.gridLayout.refreshGrid === true) {
            this.refreshGrid();
            store.dispatch(refreshGridFalse())
        }
    }
    getGridColumns = async (screenName, userId) => {
        this.setState({ loading: true });
        try {
            let response = await apiCalls.getGridMetaData(screenName, userId);
            if (response.ok) {
                const _gridJson = response.data?.gridMetaData?.replace(/\\\"/g, '"');
                const parsedData = _gridJson ? JSON.parse(_gridJson) : [];
                const isDataStateEmpty = Object.keys(parsedData?.dataState || {}).length === 0;
                const dataStateToUse = isDataStateEmpty
                    ? { skip: 0, take: this.props?.pSize || 10 }
                    : parsedData?.dataState;
                this.setState({
                    columns: parsedData?.columns,
                    dataState: dataStateToUse,
                    loading: false
                });
                this.eleRef?.current?.fetchGridCall(dataStateToUse);
            } else {
                this.setState({
                    columns: [],
                    dataState: {},
                    loading: false
                });
            }
        } catch (error) {
            console.error("Error fetching grid columns:", error);
            this.setState({
                columns: [],
                dataState: {},
                loading: false
            });
        }
    };
    refreshGrid() {
        this.eleRef.current.refreshGrid();
    }
    renderDate = (props) => {
        if (props.dataItem[props.field]) {
            return (
                <td>
                    <Moment format="DD/MM/YYYY">
                        {this.convertUTCToLocalTime(props?.dataItem[props.field])}
                    </Moment>
                </td>
            );
        } else {
            return <td>{props.dataItem[props.field]}</td>;
        }
    };
    renderDateTime = (props) => {
        if (props.dataItem[props.field]) {
            return (
                <td>
                    <Moment format="DD/MM/YYYY hh:mm:ss A" globallocal="value">
                        {this.convertUTCToLocalTime(props?.dataItem[props.field])}
                    </Moment>
                </td>
            );
        } else {
            return <td>{props.dataItem[props.field]}</td>;
        }
    };
    convertUTCToLocalTime = (dateString) => {
        let date = new Date(dateString);
        const milliseconds = Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds()
        );
        return new Date(milliseconds).toISOString();
    };
    renderNumber = () => {
        return (
            <td>
                {" "}
            </td>
        );
    };
    CustomLockedCell = (props, customCell, column) => {
        const field = props.field || "";
        const value = props.dataItem[field];
        const navigationAttributes = useTableKeyboardNavigation(props.id);
        let cellContent;
        if (customCell) {
            if (customCell === "RFP") {
                cellContent = this.props.renderCustomCell?.(props, column);
            } else {
                cellContent = customCell(props);
            }
        } else {
            cellContent = value;
        }
        return (
            <td width={column?.width}
                style={props.style}
                className={props.className}
                colSpan={props.colSpan}
                role="gridcell"
                aria-colindex={props.ariaColumnIndex}
                aria-selected={props.isSelected}
                {...{
                    [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
                }}
                {...navigationAttributes}
            >
                {cellContent}
            </td>
        );
    };
    gridFilterData = (column) => {
        if (column.filterType === "date") {
            if (column.isShowTime) {
                return this.renderDateTime;
            } else {
                return this.renderDate;
            }
        } else if (column.filterType === "number") {
            return this.renderNumber;
        } else if (column.filterType === "datetime") {
            return this.renderDateTime;
        } else {
            return null;
        }
    };
    onColumnsApply = (columnsState) => {
        this.setState({
            ...this.state,
            columns: columnsState,
            layoutHasChanged: true
        });
    };
    onSaveHandler = async () => {
        const columnsToSave = this.state.columns?.map((column) => {
            return {
                ...column,
                customCell: column.customCell ? column.customCell : null,
            }
        })
        this.setState({ ...this.state, isBtnLoading: true })
        const saveGridLayoutData = async (objs) => {
            const res = await apiCalls.gridSaveLayout(objs)
            if (res.status === 200) {
                this.setState({ ...this.state, isBtnLoading: false, layoutHasChanged: false })
                store.dispatch(saveGridLayoutFalse())
                this.statusSuccess('Layout saved successfully')
            } else {
                this.setState({ ...this.state, isBtnLoading: false })
            }
        };
        const metaData = {
            columns: columnsToSave,
            dataState: this.state.dataState
        }
        const obj = {
            "id": `00000000-0000-0000-0000-000000000000`,
            "userId": this.state.customerId,
            "permissionKey": this?.props?.screenName,
            "gridMetaData": JSON.stringify(metaData),
            "status": 1
        }
        saveGridLayoutData(obj);
        this.refreshGrid()
    }
    resetToDefault = () => {
        const resetGridLayoutData = async () => {
            const res = await apiCalls.gridResetLayout(this.props.screenName, this.state.customerId)
            if (res.status === 200) {
                this.getGridColumns(this.props.screenName, this?.state?.customerId)
                store.dispatch(resetGridLayoutFalse())
                this.statusSuccess('Layout reset successfully')
            } else {
                this.setState({ ...this.state, isBtnLoading: false })
            }
        };
        resetGridLayoutData()
    }
    clearGridFilters = () => {
        const clearFiltersData = () => {
            const updatedDataState = { ...this.state.dataState };
            updatedDataState.filter = {};
            const updatedColumns = this.state.columns.map(column => ({
                ...column,
                isFiltered: false
            }));
            this.setState({
                columns: updatedColumns,
                dataState: updatedDataState,
                loading: false
            });

            store.dispatch(clearGridFiltersFalse())
            this.eleRef?.current?.fetchGridCall(updatedDataState);
        }
        clearFiltersData();
    }

    // Inside your class component

    renderGridCell = (props, column) => {
        if (column.locked) {
            return this.CustomLockedCell(props, column.customCell, column);
        }

        if (column.customCell === "RFP") {
            return this.props?.renderCustomCell?.(props, column);
        }

        if (typeof column.customCell === 'function') {
            return column.customCell(props);
        }

        const filterCell = this.gridFilterData(column);
        return filterCell ? filterCell(props) : <td>{props.dataItem[column.field]}</td>;
    };

    renderFooterCell = (key) => {
        const total = this.eleRef?.current?.state?.data?.reduce((acc, item) => {
            const cleanValue = item[key]?.toString().replace(/,/g, '');
            const value = parseFloat(cleanValue) || 0;
            return acc + value;
        }, 0);
        const totalSum = isNaN(total) ? 0 : total;
        return (
            <td>
                {totalSum?.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}
            </td>
        );
    };

    getFooterCell = (column) => {
        if (column.footerCell === 'sum') {
            return this.renderFooterCell(column.field);
        }

        if (column.footerCell === 'footerTitle') {
            return (
                <td
                    className={`${column.locked ? "p-2 md:sticky footer-sticky left-[50px] z-[1] bg-light-layoutBg" : "p-2"} ${this.props?.totalAmountClass}`}
                >
                    Grand Total :
                </td>
            );
        }

        return (
            <td className={this.props?.showGridSelection ? "md:sticky left-0 bg-light-layoutBg" : ""}></td>
        );
    };

    // Method to render the selection checkbox cell
    renderSelectionCell = (cellProps) => {
        const itemId = cellProps.dataItem.id || cellProps?.dataItem?.transactionId;
        const isChecked = this.props?.selection?.indexOf(itemId) > -1;

        // Using bind to avoid inline arrow function for onChange, passing cellProps
        const handleChange = this.props?.handleSelection ? this.props.handleSelection.bind(null, cellProps) : undefined;

        return (
            <label className="text-center custom-checkbox">
                <input
                    id={itemId}
                    name="check"
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleChange} // Use the bound handler
                    className="c-pointer"
                />
                <span></span>
            </label>
        );
    };

    trimFilterValues = (filters) => {
        if (!filters || !Array.isArray(filters)) return [];

        const seenFilters = new Set();

        return filters
            .map(filter => {
                if (!filter) return null;

                if (Array.isArray(filter.filters)) {
                    return {
                        ...filter,
                        filters: this.trimFilterValues(filter.filters)
                    };
                }

                const filterKey = JSON.stringify({
                    field: filter.field,
                    operator: filter.operator,
                    value: typeof filter.value === 'string' ? filter.value.trim() : filter.value
                });

                if (seenFilters.has(filterKey)) return null;
                seenFilters.add(filterKey);

                return {
                    ...filter,
                    value: typeof filter.value === 'string' ? filter.value.trim() : filter.value
                };
            })
            .filter(Boolean);
    };

    // Method to render the ColumnMenu wrapper
    renderColumnMenu = (menuProps, column) => {
        const updatedProps = {
            ...menuProps,
            filter: menuProps?.filter?.filters
                ? {
                    ...menuProps.filter,
                    filters: this.trimFilterValues(menuProps.filter.filters)
                }
                : undefined
        };
        return (
            <ColumnMenu
                {...updatedProps}
                columns={this.state.columns}
                onColumnsApply={this.onColumnsApply}
                resetToDefault={this.resetToDefault}
                showDisplayColumns={this.props.showDisplayColumns}
            />
        );
    };

    gridChildrenData = (column, indx) => {
        const cell = (props) => this.renderGridCell(props, column);

        return (
            <GridColumn
                key={indx}
                locked={column.locked}
                // Pass the render function, potentially still flagged by stricter rules but moves logic out
                columnMenu={column.filter ? (menuProps) => this.renderColumnMenu(menuProps, column) : undefined}
                field={column.field}
                title={
                    <span>
                        {column.title}
                        {column.isFiltered && <span className="k-icon k-i-filter left-five" />}
                    </span>
                }
                width={column.width + (column.isFiltered ? 40 : 0)}
                cell={cell}
                filterable={column.filter}
                filter={column.filter ? column.filterType || "text" : null}
                format="{0:#,0.##########}"
                reorderable={!column.locked}
                orderIndex={column.orderIndex}
                sortable={column.sortable !== false} // Keep existing sortable logic
                // Pass function reference, arrow function needed here to capture 'column' from map scope
                footerCell={() => this.props.hasFooter ? this.getFooterCell(column) : null}
            />
        );
    };
    handleColumnReorder = (event) => {
        const reorderableColumns = event.columns.filter(column => !column.locked);
        const updatedColumns = this.state.columns.map(column => {
            if (column.locked) {
                return column;
            } else {
                const reorderedColumn = reorderableColumns.find(col => col.field === column.field);
                return {
                    ...column,
                    orderIndex: reorderedColumn ? reorderedColumn.orderIndex : column.orderIndex,
                };
            }
        });
        updatedColumns.sort((a, b) => a.orderIndex - b.orderIndex);
        this.setState({
            columns: updatedColumns,
            layoutHasChanged: true,
        });
    };

    dataStateChangeHandler = (dataState) => {
        let filterFields = []
        let filterIndex = []
        let cols = this.state.columns.map(col => ({ ...col }));
        if (dataState?.filter?.filters && dataState.filter.filters.length > 0) {
            for (let i in dataState.filter.filters) {
                filterFields.push(dataState.filter.filters[i].filters[0].field);
            }
            for (let field of filterFields) {
                for (let i in this.state.columns) {
                    if (this.state.columns[i].field === field) {
                        filterIndex.push(parseInt(i));
                        break;
                    }
                }
            }
            cols = cols.map((col, index) => ({
                ...col,
                isFiltered: filterIndex.includes(index)
            }));
        } else {
            cols = cols.map(col => ({
                ...col,
                isFiltered: false
            }));
        }
        let pageSizeToDisplay = dataState.take ? dataState.take : "All";
        this.setState(prevState => {
            const mergedFilter = dataState.filter;
            return {
                ...prevState,
                dataState: {
                    ...prevState.dataState,
                    ...dataState,
                    filter: mergedFilter,
                    take: pageSizeToDisplay
                },
                layoutHasChanged: true,
                columns: cols
            };
        });
    };


    statusSuccess = (data) => {
        message.destroy()
        message.success({
            content: data,
            className: 'custom-msg',
            duration: 4
        });
    };
    render() {
        const { url, refresh, refreshCallBack } = this.props;
        const { columns, dataState, saveGridModalIsVisible, isBtnLoading, layoutHasChanged } = this.state;
        if (refresh === true && refreshCallBack && typeof refreshCallBack === 'function') {
            this.refreshGrid()
        }
        return (
            <div>
                <Modal
                    open={saveGridModalIsVisible}
                    onCancel={this.cancelHandler}
                    title={"Save Grid Layout?"}
                    maskClosable={false}
                    closeIcon={
                        <Tooltip title="Close">
                            <span className="icon close c-pointer" />
                        </Tooltip>
                    }
                    footer={
                        <>
                            <Button type="cancel" className="cancel-btn">
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                className="primary-btn ml-8"
                                onClick={this.onSaveHandler}
                                loading={isBtnLoading}
                                disabled={!layoutHasChanged}
                            >
                                Save
                            </Button>
                        </>
                    }
                >
                    <p className="text-sm text-light-addonColor leading-normal">{layoutHasChanged ? 'Are you sure you want to save the layout?' : 'Layout has not been edited'}</p>
                </Modal>
                {<StatefullGrid
                    reorderable={true}
                    groupable={false}
                    cellRender={this.cellRender}
                    onColumnReorder={this.handleColumnReorder}
                    url={url}
                    ref={this.eleRef}
                    showExcelExport={this.props.showExcelExport}
                    callback={this.callback}
                    {...this.props}
                    getDataStateFromChild={this.dataStateChangeHandler}
                    dataState={dataState}
                    columns={columns}
                    modules={this.props?.modules}
                    loading={this.state.loading}
                >
                    <GridNoRecords>
                        <div style={{ textAlign: "center" }}>No Records Available</div>
                    </GridNoRecords>
                    {this.props?.showGridSelection && this.gridChildrenData(
                        {
                            field: "",
                            title: "",
                            width: 50,
                            filter: false,
                            sortable: false,
                            locked: true, // Ensure this is true
                            customCell: this.renderSelectionCell, // Use the class method
                        },
                        "0_check"
                    )}
                    {columns?.map((column, indx) => column.show && this.gridChildrenData(column, indx))}
                </StatefullGrid>}
            </div>
        );
    }
}
const mapStateToProps = ({ gridLayout }) => ({
    gridLayout
});
export default connect(mapStateToProps)(List);
